import fetchAllBrands from '@dehaat/kisan-app-bl/api/fetchAllBrands';
import { DEFAULT_LANG } from '@dehaat/kisan-app-bl/constants/common';
import { Brand } from '@dehaat/kisan-app-bl/models/Product';
import { GetServerSideProps } from 'next';
import Head from 'next/head';
import { useRouter } from 'next/router';
import useTranslation from 'next-translate/useTranslation';
import BrandsListing from '@/components/products/BrandsListing';
import { LAT_LNG_COOKIE_NAME, VENDOR_ID_COOKIE_NAME, WEBSITE_URL } from '@/constants/common';
interface Props {
  brands: Brand[];
}
const BrandsPage = ({
  brands
}: Props) => {
  const {
    t
  } = useTranslation('main');
  const router = useRouter();
  const localePrefix = router.locale === DEFAULT_LANG ? '' : `/${router.locale}`;
  return <>
      <Head data-sentry-element="Head" data-sentry-source-file="brands.tsx">
        <title>All Brands | DeHaat Kisan: Agriculture Marketplace</title>
        <meta name="description" content="Browse all agricultural brands available on DeHaat — seeds, fertilizers, pesticides, and more from trusted manufacturers for Indian farmers." data-sentry-element="meta" data-sentry-source-file="brands.tsx" />
        <link rel="canonical" href={`${WEBSITE_URL}${localePrefix}/brands`} />
        <link rel="alternate" hrefLang={`${router.locale}-in`} href={`${WEBSITE_URL}${localePrefix}/brands`} />
      </Head>
      <BrandsListing initialBrands={brands} heading={t('all_brands')} data-sentry-element="BrandsListing" data-sentry-source-file="brands.tsx" />
    </>;
};
export const getServerSideProps: GetServerSideProps = async ({
  req: {
    cookies
  },
  locale = DEFAULT_LANG
}) => {
  const latLng = cookies[LAT_LNG_COOKIE_NAME];
  const vendorId = cookies[VENDOR_ID_COOKIE_NAME];
  const brands = await fetchAllBrands(locale, latLng, vendorId !== 'null' ? vendorId : undefined);
  return {
    props: {
      brands
    }
  };
};
export default BrandsPage;